import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { useNativeEmoji } from 'components/block/emoji/emoji.hooks'
import { OldBrowserSupportEmojiLoadable } from 'components/block/OldBrowserSupportEmoji/OldBrowserSupportEmojiLoadable'
import { MessengerItemTypes } from 'components/page/Chat/Messenger/Messenger.constants'
import { GQLGender } from 'generated-graphql/graphql'
import { LastMessage } from 'reducers/contactList/contactList.types'

/**
 * @param lastMessage
 * @param gender
 * @param lastVisit
 * @constructor
 * Описание типов сообщений - https://redmine.mamba.ru/issues/91054#note-74
 */
export const LastMessageTextSwitcher: FC<{
  lastMessage: LastMessage
  gender: GQLGender
}> = ({ lastMessage, gender }) => {
  const { incoming } = lastMessage

  const isSupportNativeEmoji = useNativeEmoji()

  switch (lastMessage.type) {
    case MessengerItemTypes.WINK:
      if (incoming) {
        return (
          <span data-name="contact-last-message-wink-incoming-text">
            <FormattedMessage
              id="contact.last.message.wink.incoming"
              defaultMessage="{gender, select, M {подмигнул} F {подмигнула} other {подмигнул}} вам"
              values={{ gender }}
            />
          </span>
        )
      }

      return (
        <span data-name="contact-last-message-wink-text">
          <FormattedMessage
            id="contact.last.message.wink"
            defaultMessage="вы подмигнули"
          />
        </span>
      )

    case MessengerItemTypes.STICKER:
      if (incoming) {
        return (
          <span data-name="contact-last-message-sticker-incoming-text">
            <FormattedMessage
              id="contact.last.message.sticker.incoming"
              defaultMessage="{gender, select, M {прислал} F {прислала} other {прислал}} вам стикер"
              values={{ gender }}
            />
          </span>
        )
      }

      return (
        <span data-name="contact-last-message-mutual-like-incoming-text">
          <FormattedMessage
            id="contact.last.message.sticker"
            defaultMessage="вы отправили стикер"
          />
        </span>
      )

    case MessengerItemTypes.MUTUAL_LIKE:
      if (incoming) {
        return (
          <span data-name="contact-last-message-mutual-like-incoming-text">
            <FormattedMessage
              id="contact.last.message.mutual.like.incoming"
              defaultMessage="{gender, select, M {выразил} F {выразила} other {выразил}} вам взаимную симпатию"
              values={{ gender }}
            />
          </span>
        )
      }

      return (
        <span data-name="contact-last-message-mutual-like-text">
          <FormattedMessage
            id="contact.last.message.mutual.like"
            defaultMessage="вы выразили симпатию"
          />
        </span>
      )

    case MessengerItemTypes.ASK_TO_FILL_INTERESTS:
    case MessengerItemTypes.ATTACH_PHOTO:
      if (incoming) {
        return (
          <span data-name="contact-last-message-attach-photo-incoming-text">
            <FormattedMessage
              id="contact.last.message.attach.photo.incoming"
              defaultMessage="{gender, select, M {прислал} F {прислала} other {прислал}} вам изображение"
              values={{ gender }}
            />
          </span>
        )
      }

      return (
        <span data-name="contact-last-message-attach-photo-text">
          <FormattedMessage
            id="contact.last.message.attach.photo"
            defaultMessage="вы отправили изображение"
          />
        </span>
      )

    case MessengerItemTypes.Gift:
      if (incoming) {
        return (
          <span data-name="contact-last-message-gift-incoming-text">
            <FormattedMessage
              id="contact.last.message.gift.incoming"
              defaultMessage="{gender, select, M {отправил} F {отправила} other {отправил}} вам комплимент"
              values={{ gender }}
            />
          </span>
        )
      }

      return (
        <span data-name="contact-last-message-gift-text">
          <FormattedMessage
            id="contact.last.message.gift"
            defaultMessage="вы отправили комплимент"
          />
        </span>
      )

    case MessengerItemTypes.TEXT:
    case MessengerItemTypes.ApplicationMessage:

    default:
      if (!isSupportNativeEmoji) {
        return (
          <OldBrowserSupportEmojiLoadable message={lastMessage.message_text} />
        )
      }

      return <span data-name="answer-text">{lastMessage.message_text}</span>
  }
}
